"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { useCourseContext } from "~/contexts/CourseContext";
import { useUserContext } from "~/contexts/UserContext";
import { api } from "~/utils/api";

export function useAddToWatchlist() {
  const { user } = useUserContext();
  const { course } = useCourseContext();
  const router = useRouter();
  const toggleWatchlist = api.watchlist.toggleWatchlist.useMutation();
  const [watchlistError, setWatchlistError] = useState<string | null>(null);

  const addToWatchlist = async (teeTimeId: string, onSuccess?: () => unknown) => {
    setWatchlistError(null);
    if (!user) {
      router.push(`/${course?.id}/login`);
      return;
    }
    try {
      await toggleWatchlist.mutateAsync({ teeTimeId });
      await onSuccess?.();
    } catch (error) {
      setWatchlistError((error as Error)?.message ?? "Error adding to watchlist");
    }
  };

  return { addToWatchlist, watchlistError, setWatchlistError };
}
